import { render } from "./v-title.vue?vue&type=template&id=16663254&scoped=true"
import script from "./v-title.vue?vue&type=script&lang=js"
export * from "./v-title.vue?vue&type=script&lang=js"

import "./v-title.vue?vue&type=style&index=0&id=16663254&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16663254"]])

export default __exports__